addEventListener('load', () => {
    const psw = document.querySelector('.product-section-body')
    if (document.querySelector('#judgeme_product_reviews')) {
        let psr = document.querySelector('#judgeme_product_reviews');
        psw.appendChild(psr)
        psr.setAttribute('id', 'product_section_review')
        psr.classList.add("production-section-body-block");
    }
    if (document.querySelector('#product_section_specifications')) {
        let pss = document.querySelector('#product_section_specifications');
        psw.appendChild(pss);
        pss.classList.add("production-section-body-block");
    }
    if (document.querySelector('#product_section_faq')) {
        let psfaq = document.querySelector('#product_section_faq');
        psw.appendChild(psfaq);
        psfaq.classList.add("production-section-body-block");
    }

    const tabs = document.querySelectorAll(".production-section-header-block");
    const panels = document.querySelectorAll(".production-section-body-block");

    if (tabs.length > 0) {
      tabs[0].classList.add("active");
      panels[0].classList.add("active");
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        tabs.forEach(t => t.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));

        tab.classList.add("active");
        panels[index].classList.add("active");
      });
    });
})

document.addEventListener('DOMContentLoaded', () => {
  const togglers = document.querySelectorAll('[data-toggle]');

  togglers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const selector = e.currentTarget.dataset.toggle;
      const block = document.querySelector(`${selector}`);

      if (!block) {
        console.error(`Not Found: ${selector}`);
        return;
      }

      togglers.forEach((otherBtn) => {
        const otherSelector = otherBtn.dataset.toggle;
        const otherBlock = document.querySelector(`${otherSelector}`);

        if (otherBlock && otherBtn !== e.currentTarget && otherBtn.classList.contains('active')) {
          otherBlock.style.transition = 'max-height 0.3s ease';
          otherBlock.style.maxHeight = '0';
          otherBtn.classList.remove('active');
        }
      });

      if (!block.style.maxHeight || block.style.maxHeight === '0px') {
        block.style.transition = 'max-height 0.3s ease';
        block.style.maxHeight = block.scrollHeight + 'px';
      } else {
        block.style.transition = 'max-height 0.3s ease';
        block.style.maxHeight = '0';
      }

      e.currentTarget.classList.toggle('active');
    });
  });
});